import styled from 'styled-components';
import { ReactComponent as TagSVG } from 'Images/icon-action-bar-tags.svg';

export const TagIcon = styled(TagSVG)`
    height: 17px;
    g > path {
      fill: ${({ theme }) => theme.icons.actionBar.color};
    }
`;
TagIcon.displayName = 'Tag';

export default TagIcon;
